import { StoreReviewType } from "features/storeReviews/types";
import React from "react";
import { MdStar } from "react-icons/md";
import styled from "styled-components/macro";
import { device, toRem } from "theme/Breakpoints";
import { DefaultText, shadow } from "theme/GlobalElements";
import { colors } from "theme/Theme";

interface StoreReviewProps {
  review: StoreReviewType;
}

const StoreReview: React.FC<StoreReviewProps> = ({ review }) => {
  const { title, reviewerName, location, rating, content } = review;

  return (
    <StoreReviewContainer>
      <TopSectionContainer>
        <Title className="text-body">{title}</Title>
        <Date className="text-xs">{reviewerName}</Date>
      </TopSectionContainer>
      <SourceTitle className="text-xs">{location}</SourceTitle>
      <StarsContainer>
        {[1, 2, 3, 4, 5].map((item) => {
          return (
            <MdStar
              key={item}
              style={{
                width: 24,
                height: 24,
                fill: "#FFC107",
              }}
            />
          );
        })}
      </StarsContainer>
      <Content className="text-body">{content}</Content>
    </StoreReviewContainer>
  );
};

const StoreReviewContainer = styled.div`
  ${shadow}
  border-radius: 5px;
  width: 90%;
  background-color: white;
  padding: 10px;
  margin-bottom: 50px;

  p + p {
    margin-top: 5px;
  }

  @media only screen and (${device.laptop}) {
  }
`;

const TopSectionContainer = styled.div`
  display: flex;
  flex-direction: row nowrap;
  justify-content: space-between;
`;

const Title = styled(DefaultText)`
  font-weight: 500;
`;
const Date = styled(DefaultText)`
  color: ${colors.dark_gray};
`;

const SourceTitle = styled(DefaultText)`
  color: ${colors.dark_gray};
`;

const StarsContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  margin-bottom: 10px;
`;

const Content = styled(DefaultText)``;

export default StoreReview;
